// @flow
import { Link } from 'react-router-dom'
import React, { Component } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/message.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/card.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/button.css'
import { LocaleContext } from '../../contexts/locale'
import config from 'config'
import './styles.scss'

import de from './locales/de.yml'
import fr from './locales/fr.yml'

const MESSAGES = { de, fr }

console.log(MESSAGES)

type Props = {
  handleTeamSelection: (teamId: number) => void
}

type Team = {
  ID: Number,
  Name: string,
  LeagueName: string,
  ClubNumber: string
}

type State = {
  teams: Array<Team>
}

export class TeamSelection extends Component<Props, State> {
  componentWillMount() {
    // Get the teams from the selected region not forgetting the
    // first league and amateur league teams
    /* let teams = [
      ...require('../../data/LA_teams.csv'),
      ...require('../../data/' +
        this.props.match.params.associationId +
        '_teams' +
        '.csv')
    ] */
    let teams = require('../../data/all_teams.csv')

    // Filter all the teams that are part of the selected club
    teams = teams.filter(
      team => team.ClubNumber === this.props.match.params.clubId
    )

    // Check whether the team has a text or not
    console.log(teams)

    // Check whether the club has more than one team
    // if the club has only one team, go directly to the article
    if (teams.length === 1) {
      this.props.history.replace(config.routes.articleLastMatch + teams[0].ID)
    }

    // Set the new state with the proper list of teams
    this.setState({
      teams: teams
    })
  }

  static contextType = LocaleContext

  render() {
    const t = config.translationServiceFactory(MESSAGES, this.context)

    return (
      <div className='step questionnaire'>
        <h3 className='ui header'>
          <div className='sub header'>{t('title')}</div>
          {t('subtitle')}
        </h3>

        <div className='ui vertical very fitted segment'>
          <div className='results ui bottom attached segment'>
            {this.state.teams.map((team, index) => (
              <div
                className='item'
                key={index}
                tabIndex={0}
                onClick={() => {
                  this.props.handleTeamSelection(team.ID)
                }}
              >
                <div className='content'>
                  <div className='header'>{team.Name}</div>
                  <div className='meta'>
                    {MESSAGES.de.gender[team.LeagueGender]} -{' '}
                    {team.LeagueNameDE}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className='ui vertical right aligned segment'>
          <div className='ui large buttons mobile hidden'>
            <Link to='/' className='ui basic labeled icon button'>
              <i className='left chevron icon' />
              {t('general.back')}
            </Link>
          </div>

          <div className='ui large vertical buttons mobile only'>
            <Link to='/' className='ui basic labeled icon button'>
              <i className='left chevron icon' />
              {t('general.back')}
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

export default TeamSelection
